const ENTRYPOINT = process.env.REACT_APP_API_URL

const authProvider = {
    login: ({ username, password }) => {
        const request = new Request(ENTRYPOINT + '/api/authentication-token', {
            method: 'POST',
            body: JSON.stringify({
                email: username,
                password: password,
            }),
            headers: {
                'accept': 'application/json',
                'content-type': 'application/json',
            },
        })

        return fetch(request)
            .then((response) => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText)
                }

                return response.json()
            })
            .then(({ token }) => localStorage.setItem('token', token))
    },
    logout: () => {
        localStorage.removeItem('token')

        return Promise.resolve()
    },
    checkError: ({ status }) => {
        if (status === 401 || status === 403) {
            localStorage.removeItem('token')
        }

        return Promise.resolve()
    },
    checkAuth: () => {
        return localStorage.getItem('token') ? Promise.resolve() : Promise.reject()
    },
    getPermissions: () => {
        return []
    },
}

export default authProvider
